import React, {useEffect, useMemo} from 'react';
import styled from "styled-components";
import HistoryContentDayInfo from "./HistoryContentDayInfo";
import HistoryContentPatchInfo from "./HistoryContentPatchInfo";

const Wrapper = styled.div`
  margin: 6px 0;
  display: flex;
  flex-direction: row;
  border: 1px solid #A5BED2;
  background: #fff;
  padding: 12px 14px;
`;


const ChampionHistoryContent = ({patchHistory,champion,aram}) => {


    return (
        <Wrapper>
            <HistoryContentDayInfo
                correction={patchHistory.correction}
                version={patchHistory.version}
                date={patchHistory.reg_date}
                hotfix={patchHistory.hot_fix}
            />
            <HistoryContentPatchInfo
                type={patchHistory.type}
                aram={aram?.skill_history_list}
                version={patchHistory.version}
                champion={champion}
                list={patchHistory.skill_history_list}
            />
        </Wrapper>
    );
};

export default ChampionHistoryContent;
